<template>
  <div class="w-full text-white">
    <div
      class="bg-white rounded-xl lg:h-12 filter-wrapper mb-8 flex flex-wrap lg:flex-nowrap"
    >
      <div
        class="rounded-xl relative flex lg:space-x-2 text-black flex-wrap lg:flex-nowrap w-full lg:w-auto"
      >
        <!-- keyword search -->
        <TextInput
          v-if="showFilterDD"
          :value="filterPostsBy.keywords"
          :label="'Searching for...'"
          :placeholder="'Enter Keywords'"
          :textarea="false"
          :placeholder_black="true"
          :fixed_width="true"
          :margin_bottom="false"
          :search_icon="true"
          :border_enabled="false"
          :response_selection_id="'filter_post_keywords'"
        />

        <!-- seperater && category -->
        <div
          v-if="settings.post_categories"
          class="w-px h-10 relative top-1 bg-truegray-300 hidden lg:block"
        ></div>
        <InputDropdown
          v-if="showFilterDD"
          :label="'Category'"
          :selected-options-initial="[filterPostsBy.category]"
          :placeholder-default="'Choose your category...'"
          :options="settings.post_categories"
          :fixed-width="true"
          :text-xs="true"
          :margin-bottom="false"
          :border-enabled="false"
          :shadow-enabled="false"
          :response-selection-id="'filter_post_categories'"
        />

        <!-- seperater && tags -->
        <div
          v-if="settings.tags"
          class="w-px h-10 relative top-1 bg-truegray-300 hidden lg:block"
        ></div>
        <InputDropdown
          v-if="showFilterDD && settings.tags"
          :label="'Tags'"
          :selected-options-initial="[filterPostsBy.tag]"
          :placeholder-default="'Choose your tag...'"
          :options="settings.tags"
          :fixed-width="true"
          :text-xs="true"
          :margin-bottom="false"
          :border-enabled="false"
          :shadow-enabled="false"
          :response-selection-id="'filter_post_tags'"
        />
      </div>

      <!-- Search button -->
      <button
        class="btn relative w-full lg:w-40 h-12 lg:h-full p-0 m-0 ml-auto font-primary"
        :disabled="thinking"
        :class="thinking ? 'bg-primary cursor-not-allowed' : 'btn-primary'"
        @click="submitFilterOptions"
      >
        <div
          class="absolute inset-0 w-full flex justify-center items-center z-20"
        >
          <lottie v-if="thinking" :options="loadingAnimationOptions" />
        </div>
        <span :class="[thinking ? 'invisible' : '']">Search</span>
      </button>
    </div>

    <div class="w-full flex justify-start space-x-4 items-center">
      <button
        :class="[resetFiltersDisabled ? 'opacity-25 cursor-not-allowed' : '']"
        :disabled="resetFiltersDisabled"
        type="button"
        class="flex items-center cursor-pointer group"
        @click="resetFilters"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 mr-2 transform group-hover:rotate-90 transition-all duration-300 ease-in-out"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
        <span>Clear filters</span>
      </button>

      <!-- TOGGLE -->
      <div v-if="userAccess" class="flex justify-start items-center space-x-2">
        <button
          type="button"
          class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"
          :class="[draft_posts ? 'bg-primary' : 'bg-gray-200']"
          role="switch"
          aria-checked="false"
          @click="draft_posts = !draft_posts"
        >
          <span
            aria-hidden="true"
            class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
            :class="[draft_posts ? 'translate-x-5' : 'translate-x-0']"
          ></span>
        </button>
        <span v-if="draft_posts">Drafts</span>
        <span v-if="!draft_posts">Published</span>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus.js'
import InputDropdown from '../../../shared/components/InputDropdown.vue'
import TextInput from '../../../shared/components/InputText.vue'
import { mapActions, mapGetters } from 'vuex'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default {
  components: {
    InputDropdown,
    TextInput,
  },

  props: {
    draft: { default: false },
    parent: { default: false },
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      thinking: false,
      filterCategory: null,
      filterYear: null,
      filterTag: null,
      filterKeywords: null,
      showFilterDD: false,
      draft_posts: false,
      resetFiltersDisabled: true,
    }
  },

  computed: {
    // Set all map getters
    ...mapGetters({
      settings: 'shared/getSettings',
      userAccess: 'shared/getUserAccess',
      filterPostsBy: 'shared/getFilterPostsBy',
    }),
  },

  watch: {
    filterPostsBy: {
      handler: function (data) {
        if (
          data.category !== null ||
          data.draft !== null ||
          data.hub !== null ||
          data.keywords !== null ||
          data.tag !== null ||
          data.year !== null
        ) {
          this.$set(this, 'resetFiltersDisabled', false)
        } else {
          this.$set(this, 'resetFiltersDisabled', true)
        }
      },

      deep: true,
    },

    draft_posts: {
      handler: function (val) {
        const payload = {
          draft: val ? 1 : null,
        }

        this.dispatchSetFilterPostsBy(payload)
      },

      deep: true,
    },
  },

  mounted() {
    this.dispatchSetFilterPostsBy({ reset: true })

    if (this.draft) {
      this.$set(this, 'draft_posts', true)
    }

    EventBus.$on('getUpdatedPostsFromFilterComponent', () => {
      this.submitFilterOptions()
    })

    EventBus.$on('filter_posts_search_response_completed', () => {
      this.$set(this, 'thinking', false)
    })

    EventBus.$on('filter_post_categories', (option) => {
      this.dispatchSetFilterPostsBy({ category: option })
    })

    EventBus.$on('filter_tag_years', (option) => {
      this.dispatchSetFilterPostsBy({ year: option })
    })

    EventBus.$on('filter_post_tags', (option) => {
      this.dispatchSetFilterPostsBy({ tag: option })
    })

    EventBus.$on('filter_post_keywords', (option) => {
      this.dispatchSetFilterPostsBy({ keywords: option })
    })

    this.$set(this, 'showFilterDD', true)
  },

  methods: {
    ...mapActions({
      dispatchSetFilterPostsBy: 'shared/dispatchSetFilterPostsBy',
    }),

    resetFilters() {
      this.$set(this, 'draft_posts', false)
      this.$set(this, 'showFilterDD', false)

      setTimeout(() => {
        this.$set(this, 'showFilterDD', true)
      }, 1)

      this.dispatchSetFilterPostsBy({ reset: true })
      // this.submitFilterOptions();
    },

    submitFilterOptions() {
      this.$set(this, 'thinking', true)
      EventBus.$emit('getPostsWithFilterOptions', this.parent)
    },
  },
}
</script>

<style scoped>
@media screen and (min-width: 1024px) {
  .filter-wrapper {
    width: max-content;
  }
}
</style>
